import { useOidcUserProfile } from '@vs/oidc-client';
import { useAccountFindQuery } from '@vs/rtk/slices/apiVsAccount2';

export function useAccountInfo(opts?: { skip?: boolean }) {
  const oidcProfile = useOidcUserProfile();

  return useAccountFindQuery(
    {
      accountId: oidcProfile?.sub ?? '',
    },
    { ...opts, skip: !oidcProfile?.sub || opts?.skip }
  );
}

export default useAccountInfo;
